import { cardsData } from '@/mocks/homeData';

export default function SectionCards() {
  return (
    <section id="cards" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
            实时追踪
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">今日爆料</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">最新鲜的热门爆料，最劲爆的独家内幕，每日更新不停歇</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((card) => (
            <article
              key={card.id}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  title={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-[11px] font-medium rounded-full bg-accent-500 text-background-50 whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors duration-200">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.summary}
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{card.time}</span>
                  <span className="text-xs font-medium text-primary-600">{card.hot}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}